
// 创建plugins/watermark.js文件
/**  水印添加方法  */
 
let setWatermark = (str1, str2) => {
  let id = '1.23452384164.123412415'
 
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }
 
  let can = document.createElement('canvas')
  // 设置canvas画布大小
  can.width = 260
  can.height = 130
 
  let cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180) // 水印旋转角度
  cans.font = '26px Vedana'
  cans.fillStyle = '#999'
  cans.textAlign = 'right'
  cans.textBaseline = 'bottom' // 这里要小写！注意大小写
  let hhh = can.height*0.75 // 为了能让水印更贴合页面顶部而对高度作出限制
  // 这一块看不懂就参考这个页面：https://www.runoob.com/tags/canvas-textbaseline.html
  cans.fillText(str1, can.width / 2, hhh) // 水印在画布的位置x，y轴
  cans.fillText(str2, can.width / 2, hhh + 22) // 第二行水印，这里暂时用不到
 
  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none' // 元素不会成为鼠标事件的target
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.opacity = '0.15'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height = document.documentElement.clientHeight  + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}
 
// 添加水印方法
export const setWaterMark = (str1, str2) => {
  let id = setWatermark(str1, str2)
  if (document.getElementById(id) === null) {
    id = setWatermark(str1, str2)
  }
}
 
// 移除水印方法
export const removeWatermark = () => {
  let id = '1.23452384164.123412415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }
}
